<template>
    <div class="card">
        <div :class="['card-banner', `banner-${sort}`]">
            <div class="banner-item" v-for="(content, index) in topContent" :key="index" v-html="content.content"></div>
        </div>
        <div class="card-tag">
            <div :class="['tag', activeTag === index ? 'active' : '']" v-for="(tag, index) in tagList" :key="index" @click="handleActiveIndex(tag, index)">
                {{ tag.name }}
            </div>
        </div>
        <div class="card-content">
            <el-scrollbar>
                <transition-group name="fade" tag="div" class="card-view">
                    <div class="card-item" v-for="(card, index) in activeList" :key="index" @click="handleClick(card)">
                        <div class="card-item__image">
                            <el-image :src="card.imagePath"></el-image>
                        </div>
                        <div class="card-item__title">
                            {{ card.title }}
                        </div>
                        <div class="card-item__content">
                            {{ card.introduction }}
                        </div>
                        <div class="card-item__button">
                            了解详情&nbsp;&nbsp;>
                        </div>
                    </div>
                </transition-group>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
import {tableData} from "@/common/api";
import {useStore} from "vuex";
import router from "@/route";
import mixin from "@/mixin"
import {gsap} from "gsap";
import {ElMessage} from "element-plus";
import axios from "axios";
import {cancelPendingRequest} from "@/common/http";

export default {
    name: "cardVue",
    data() {
        return {
            topContent: [],
            store: useStore(),
            activeTag: 0,
            tagList: [],
            activeList: [],
            cardList: [],
            firstMenuContent: [],
        }
    },
    mixins: [mixin],
    props: {
        sort: {
            type: Number,
            default: 0
        },
        childrenList: {
            type: Array,
            default: ()=>[]
        },
        level: {
            type: Number,
            default: 1
        }
    },
    methods: {
        handleClick(data) {
            setTimeout(()=> {
                router.push({
                    path: `/cvi/home/article/view`,
                    query: {
                        newId: data.id,
                        parentId: new URL(location.href).searchParams.get('parentId'),
                        activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                        activeTag: new URL(location.href).searchParams.get('activeTag'),
                        type: 0
                    }
                })
            })
        },
        handleActiveIndex(item, index) {
            console.log(this.source)
            if (this.source) {
                this.source.cancel('Operation canceled by the user.'); // 取消请求
            }
            this.activeTag = index
            router.push({
                path: location.pathname,
                query: {
                    menuId: item.id,
                    level: item.level,
                    parentId: new URL(location.href).searchParams.get('parentId'),
                    activeTag: index,
                    activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                }
            })
        },
        mergedArray(array1, array2){
            let newArray = [];
            array1.map(item1 => {
                const matchingItem = array2.find(item2 => item2.menuId === item1.id);
                newArray.push({ ...item1, ...matchingItem })
            });
            return newArray
        },
        getContentData(data) {
            this.source = axios.CancelToken.source()
            cancelPendingRequest();
            tableData(data.id,{
                cancelToken: this.source.token // 将CancelToken传递给请求
            }).then(res=>{
                if(res.success) {
                    this.activeList = res.data;
                }else {
                    ElMessage.error(res.msg)
                }
            }).catch((e)=>{
                if(e.message === "canceled") {
                    console.log("请求取消了")
                }else {
                    ElMessage.error("获取资源失败，请重试")
                }
            })
        }
    },
    beforeUnmount() {
        gsap.killTweensOf(".card-banner")
    },
    mounted() {
        this.$nextTick(()=>{
            gsap.set(".card-banner", {
                opacity: 0
            })
            gsap.to(".card-banner",{
                opacity: 1,
                duration: 1.5
            })
            const parentId = new URL(location.href).searchParams.get('parentId')
            const level = new URL(location.href).searchParams.get('level')
            const menuId = new URL(location.href).searchParams.get('menuId')
            let array = [];
            if(level === "1") {
                array = this.store.getters.getMenuList.filter(e=> e.id === menuId)[0].list
                this.activeTag = 0
            }else if(level === "2") {
                array = this.store.getters.getMenuList.filter(e=> e.id === parentId)[0].list
                let dix = array.findIndex(e=>e.id === menuId)
                this.activeTag = dix > -1 ? dix : 0
            }
            console.log(this.activeTag)
            this.tagList = array
            this.getContentData(this.tagList[this.activeTag])
        })
    },
    created() {
        this.getBanner();
    }
}
</script>

<style lang="less" scoped>
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter-active{
        transition: opacity 0.5s;
    }
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
    .card {
        display: flex;
        flex-direction: column;
        background-color: #FFFFFF;
        padding-bottom: 90px;
        .card-banner {
            width: 100%;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
            &.banner-1 {
                background-image: url("~@/assets/banner-sort-1.png");
            }
            ::v-deep img {
                width: 100% !important;
            }
        }
        .card-tag {
            margin: 20px auto 0;
            width: 1200px;
            display: flex;
            flex-wrap: wrap;
            .tag {
                cursor: pointer;
                margin:20px 8px 0 0;
                flex: 1;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #F6F6F6;
                font-weight: bold;
                font-size: 15px;
                color: #333333;
                cursor: pointer;
                transition: background-color 0.1s;
                &:hover {
                    background-color: #FF6900;
                    color: #FFFFFF;
                }
                &:nth-of-type(4) {
                    padding: 0 20px;
                }
                &:nth-last-of-type(1) {
                    margin-right: 0;
                }
                &.active {
                    background-color: #FF6900;
                    color: #FFFFFF;
                }
            }
        }
        .card-content {
            margin: 40px auto 0;
            width: 1200px;
            min-height: 300px;
            display: flex;
            flex-wrap: wrap;
            ::v-deep .el-scrollbar__view{
                .card-view {
                    display: grid;
                    grid-auto-flow: row;
                    grid-template-columns: repeat(3, 1fr);
                    grid-template-rows: repeat(2, 1fr);
                    grid-column-gap: 30px;
                    grid-row-gap: 30px;
                }
                .card-item {
                    width: 380px;
                    height: 400px;
                    display: flex;
                    flex-direction: column;
                    background-color: #F6F6F6;
                    cursor: pointer;
                    .el-image__inner{
                        transform: scale(1.1);
                        transition: transform 3s;
                    }
                    &:hover {
                        .el-image__inner{
                            transform: scale(1);
                        }
                    }
                    .card-item__image{
                        height: 210px;
                        background-image: url("~@/assets/room-image.png");
                        background-repeat: no-repeat;
                        background-size: 110% 110%;
                        background-position: center center;
                        overflow: hidden;
                    }
                    .card-item__title {
                        margin: 22px 24px 0;
                        font-size: 16px;
                        font-weight: bold;
                        color: #333333;
                    }
                    .card-item__content {
                        font-size: 14px;
                        color: #666666;
                        height: 45px;
                        line-height: 1.5;
                        margin: 12px 24px 16px;
                        white-space: normal;
                        word-break: break-all;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        // 禁用自动添加浏览器前缀
                        /* autoprefixer: off */
                        display: -webkit-box;
                        -webkit-line-clamp: 2;// 代表文本超长最多显示2行，可自行调整最多显示的行数
                        -webkit-box-orient: vertical;
                    }
                    .card-item__button {
                        flex: 1;
                        margin: 0 24px;
                        border-top: 1px solid #dfdfdf;
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        justify-content: flex-end;
                        color: #FF6900;
                    }
                    &:nth-of-type(3n) {
                        margin-right: 0;
                    }
                }
            }

        }
    }
</style>
